import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { ReportParameter, ReportParameterCreate, ReportParameterFilter } from '../data/reportParameter';

export function createReportParameterService(client: AxiosInstance) {
  return createCrudService<ReportParameter, ReportParameterCreate, ReportParameterFilter>(
    client,
    '/reporting/ReportParameter',
    'id',
  );
}

export type ReportParameterService = CrudService<ReportParameter, ReportParameterCreate, ReportParameterFilter>;
